export function SeverityChip({ severity, size = 'sm', outline = false }) {
  const label = severity === 'red' ? 'Critical' : severity === 'orange' ? 'Urgent' : 'Info';
  const cls = outline ? `chip chip-outline-${severity}` : `chip chip-${severity}`;
  const dot = severity === 'red' ? '#E11D48' : severity === 'orange' ? '#F7941D' : '#FBBF24';
  return (
    <span className={cls} style={size === 'lg' ? { padding: '6px 14px', fontSize: '13px' } : {}} data-testid={`severity-${severity}`}>
      <span className="w-2 h-2 rounded-full" style={{ background: outline ? dot : 'currentColor', boxShadow: outline ? 'none' : '0 0 0 2px rgba(255,255,255,0.4)' }} />
      {label}
    </span>
  );
}

export function severityRank(s) { return { yellow: 1, orange: 2, red: 3 }[s] || 0; }
export const SEVERITY_COLORS = {
  red: '#E11D48',
  orange: '#F7941D',
  yellow: '#FBBF24',
};
